
const config = JSON.parse(localStorage.getItem('config'));

export default config;